export const SQUARE_LOGO = 'square';
export const RECTANGLE_LOGO = 'rectangle';

export const PRIMARY_COLOR = 'primaryColor';
export const SECONDARY_COLOR = 'secondaryColor';

export const PLACEHOLDER = 'placeholder';
